export const PDF_HEADER = {
    pt: [
        {
            _id: 'date',
            name: 'Data',
        },
        {
            _id: 'vigilant',
            name: 'Vigilante',
        },
        {
            _id: 'isAttendance',
            name: 'Atendido',
        },
        {
            _id: 'attendanceStatus',
            name: 'Status',
        },
        {
            _id: 'operator',
            name: 'Operador',
        },
        {
            _id: 'openedDate',
            name: 'Abertura',
        },
        {
            _id: 'closedDate',
            name: 'Fechamento',
        },
        {
            _id: 'photoURL',
            name: 'Foto',
        },
        {
            _id: 'signatureURL',
            name: 'Assinatura',
        },
        {
            _id: 'notes',
            name: 'Notas',
        },
    ],
    en: [
        {
            _id: 'date',
            name: 'Date',
        },
        {
            _id: 'vigilant',
            name: 'Vigilant',
        },
        {
            _id: 'isAttendance',
            name: 'Attendance',
        },
        {
            _id: 'attendanceStatus',
            name: 'Status',
        },
        {
            _id: 'operator',
            name: 'Operator',
        },
        {
            _id: 'openedDate',
            name: 'Opened',
        },
        {
            _id: 'closedDate',
            name: 'Closed',
        },
        {
            _id: 'photoURL',
            name: 'Photo',
        },
        {
            _id: 'signatureURL',
            name: 'Signature',
        },
        {
            _id: 'notes',
            name: 'Notes',
        },
    ],
}
